import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { name: 'Funkcje', href: '#features' },
    { name: 'Rozwiązania', href: '#solutions' },
    { name: 'Cennik', href: '#pricing' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Kontakt', href: '#contact' }
  ];

  // Updated to point to the new application URL
  const APP_URL = "https://app.rzutnieruchomosci.pl/";

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'glass-header py-4' : 'bg-transparent py-5 border-b border-transparent'}`}>
      <div className="max-w-8xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <div className="flex-1 md:flex-none">
          <a href="#" className="flex items-center">
            <img 
              src="https://media.swipepages.com/2025/11/615ca9d98dcf7f0011c44053/rzut-nieruchomosci-l.png" 
              alt="Logo" 
              className="h-[36px] w-auto object-contain transition-transform hover:scale-[1.02]" 
            />
          </a>
        </div>

        {/* Center Nav */}
        <nav className="hidden md:flex items-center justify-center flex-1 gap-8">
          {links.map(link => (
            <a key={link.name} href={link.href} className="text-[14px] font-medium text-gray-500 hover:text-gray-900 transition-colors">
              {link.name}
            </a>
          ))}
        </nav>

        {/* Right Actions */}
        <div className="hidden md:flex items-center justify-end flex-1 gap-4">
          <a 
            href={APP_URL} 
            className="text-[14px] font-medium text-gray-600 hover:text-gray-900 transition-colors px-2"
          >
            Zaloguj się
          </a>
          <a 
            href={APP_URL} 
            className="bg-[#1F2937] text-white px-4 py-2 rounded-lg text-[14px] font-semibold transition-all hover:bg-gray-800 shadow-sm"
          >
            Załóż konto
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <FiX size={20} /> : <FiMenu size={20} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-200/60 p-6 flex flex-col gap-4 shadow-lg">
          {links.map(link => (
            <a key={link.name} href={link.href} className="text-base font-semibold text-gray-800" onClick={() => setIsMobileMenuOpen(false)}>
              {link.name}
            </a>
          ))}
          <div className="h-px bg-gray-100 my-2"></div>
          <a href={APP_URL} className="w-full py-2.5 text-center font-semibold text-gray-600 border border-gray-200 rounded-lg">Zaloguj się</a>
          <a href={APP_URL} className="w-full py-2.5 text-center font-semibold bg-[#1F2937] text-white rounded-lg">Załóż konto</a>
        </div>
      )}
    </header>
  );
}